export default __webpack_public_path__ + "static/media/service-4.7d96e96f.svg";